import bdServices from '../bd-services'
import bdServices125 from '../bd-services125'
import irgeApiServices from '../irgeLocal'

var FormData = require('form-data')
const currentUrl = window.location.hostname

const facturasServices = {}

facturasServices.getFacturas = async function (fecha_jornada) {
  let formData = new FormData()
  formData.append('f_j', fecha_jornada)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/facturas/TPA/getFacturas.php'
  }
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

facturasServices.getFacturasIRGE = async function (fecha_jornada) {
  let formData = new FormData()
  formData.append('f_j', fecha_jornada)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/facturas/IRGE/getFacturas.php'
  }
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

facturasServices.getFactura_Id = async function (embarque) {
  const data = await bdServices.get(`/servidores/facturas/TPA/getFacturas_Id.php?e=${embarque}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

facturasServices.getEmbarqueInd = async function (embarque) {
  let formData = new FormData()
  formData.append('embarque', embarque)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/facturas/TPA/getDatosCargas.php'
  }
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

  

facturasServices.getEmbarqueIndIRGE = async function (embarque) {
  let formData = new FormData()
  formData.append('embarque', embarque)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/facturas/IRGE/getDatosCargas.php'
  }
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

facturasServices.addFactura_Xml = async function (embarque, fecha_fact, fecha_jornada, fileFactura, fileXml) {
  let formData = new FormData()
  formData.append('embarque', embarque)
  formData.append('fecha_fact', fecha_fact)
  formData.append('fecha_jornada', fecha_jornada)
  formData.append('fileFactura', fileFactura)
  formData.append('fileXml', fileXml)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/facturas/TPA/subirFactura.php'
  }
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

facturasServices.addFactura_XmlIRGE = async function (embarque, fecha_fact, fecha_jornada, fileFactura, fileXml) {
  let formData = new FormData()
  formData.append('embarque', embarque)
  formData.append('fecha_fact', fecha_fact)
  formData.append('fecha_jornada', fecha_jornada)
  formData.append('fileFactura', fileFactura)
  formData.append('fileXml', fileXml)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/facturas/IRGE/subirFactura.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

facturasServices.deleteFactura = function (embarque) {
  let formData = new FormData()
  formData.append('embarque', embarque)
  console.log(formData)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/facturas/TPA/deleteFactura.php'
  }
  return bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
}

facturasServices.deleteFacturaIRGE = async function (embarque) {
  let formData = new FormData()
  formData.append('embarque', embarque)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/facturas/IRGE/deleteFactura.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

facturasServices.checkFacturasNuevas = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/facturas/IRGE/checkFacturasNuevas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data 
  } else {
    const data = await bdServices.get(`/servidores/facturas/IRGE/checkFacturasNuevas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
  
}

facturasServices.checkFacturasNuevasIRGE = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await irgeApiServices.get(`/servidores/facturas/IRGE/checkFacturasNuevas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data 
  } else {
    const data = await irgeApiServices.get(`/servidores/facturas/IRGE/checkFacturasNuevas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
  
}

facturasServices.enviarMailPropangol = async function (cant) {
  let formData = new FormData()
  formData.append('cant', cant)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/facturas/IRGE/enviarEmail.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await irgeApiServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

export default facturasServices


// WEBPACK FOOTER //
// ./src/services/facturas/facturas.js